import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useAuth } from "../../../../../context/AuthContext";
import { EXPRESS_BASE_URL } from "../../../../../Helpers/apiConfig";

const EXPRESS_API = EXPRESS_BASE_URL;

export const AdminQuestionTemplates = () => {
    const { user } = useAuth();
    const [templates, setTemplates] = useState([]);
    const [rules, setRules] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedTypeFilter, setSelectedTypeFilter] = useState("");

    // Modal State'leri
    const [showModal, setShowModal] = useState(false);
    const [modalMode, setModalMode] = useState("create"); // 'create' or 'edit'
    const [currentId, setCurrentId] = useState(null);

    // Form State (is_active tamamen kaldırıldı, backend zaten varsayılan 1 alıyor)
    const [formData, setFormData] = useState({
        name: "",
        description: "",
        content_type: "choice",
        tag_id: 1,
        title_media: "text",
        left_media: "",
        answer_media: "",
        answer_language: "en",
        instruction: "",
        item_count: 3,
        option_count: 3,
        piece_mode: "letters",
        notfy_text: "",
        sortid: 0
    });

    const headers = {
        Authorization: `Bearer ${user?.token}`,
    };

    const fetchRulesAndTemplates = async (contentType = "") => {
        setLoading(true);
        try {
            const rulesRes = await axios.get(`${EXPRESS_API}/api/question-templates/rules`, { headers });
            if (rulesRes.data.success) {
                setRules(rulesRes.data.data);
            }

            let url = `${EXPRESS_API}/api/question-templates`;
            if (contentType) {
                url += `?content_type=${contentType}`;
            }

            const templatesRes = await axios.get(url, { headers });
            if (templatesRes.data.success) {
                setTemplates(templatesRes.data.data);
            }
        } catch (err) {
            console.error("Veriler yüklenemedi", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRulesAndTemplates(selectedTypeFilter);
    }, [selectedTypeFilter]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    // Soru türü değiştiğinde kurallara göre varsayılan değerleri atar
    const handleContentTypeChange = (e) => {
        const newType = e.target.value;
        const typeRule = rules?.types[newType];
        
        setFormData(prev => ({
            ...prev,
            content_type: newType,
            title_media: typeRule?.titleMedia?.[0] || "text",
            left_media: typeRule?.leftMedia ? typeRule.leftMedia[0] : "",
            answer_media: typeRule?.answerMedia ? typeRule.answerMedia[0] : "",
            item_count: typeRule?.itemCount ? typeRule.itemCount.default : null,
            option_count: typeRule?.optionCount ? typeRule.optionCount.default : null,
            piece_mode: typeRule?.pieceMode ? typeRule.pieceMode.default : null,
            instruction: typeRule?.instructions?.[0] || ""
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (modalMode === "create") {
                await axios.post(`${EXPRESS_API}/api/question-templates`, formData, { headers });
                Swal.fire("Başarılı", "Şablon oluşturuldu.", "success");
            } else {
                await axios.put(`${EXPRESS_API}/api/question-templates/${currentId}`, formData, { headers });
                Swal.fire("Başarılı", "Şablon güncellendi.", "success");
            }
            setShowModal(false);
            fetchRulesAndTemplates(selectedTypeFilter);
        } catch (err) {
            Swal.fire("Hata", err.response?.data?.message || "Bir hata oluştu", "error");
        }
    };

    const handleDuplicate = async (id) => {
        try {
            const res = await axios.post(`${EXPRESS_API}/api/question-templates/${id}/duplicate`, {}, { headers });
            if (res.data.success) {
                Swal.fire("Başarılı", "Şablon kopyalandı.", "success");
                fetchRulesAndTemplates(selectedTypeFilter);
            }
        } catch (err) {
            Swal.fire("Hata", "Kopyalama başarısız.", "error");
        }
    };

    const handleDelete = async (id) => {
        const confirm = await Swal.fire({
            title: "Bu şablonu silmek istediğinize emin misiniz?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Evet, Sil",
            cancelButtonText: "Vazgeç"
        });

        if (!confirm.isConfirmed) return;

        try {
            await axios.delete(`${EXPRESS_API}/api/question-templates/${id}`, { headers });
            Swal.fire("Başarılı", "Şablon silindi.", "success");
            setTemplates(prev => prev.filter(t => t.id !== id));
        } catch (err) {
            Swal.fire("Hata", "Silme işlemi başarısız.", "error");
        }
    };

    const activeRule = rules?.types?.[formData.content_type];

    return (
        <div className="container-fluid py-4 bg-light min-vh-100">
            {/* ÜST BAŞLIK VE FİLTRELEME */}
            <div className="card shadow-sm border-0 mb-4 p-3">
                <div className="row align-items-center">
                    <div className="col-md-4">
                        <h3 className="fw-bold text-primary m-0">Soru Türü & Şablon Yönetimi</h3>
                        <small className="text-muted">Soru üretimi ve şablon kurallarını yönetin</small>
                    </div>
                    <div className="col-md-4 text-center">
                        <select 
                            className="form-select"
                            value={selectedTypeFilter}
                            onChange={(e) => setSelectedTypeFilter(e.target.value)}
                        >
                            <option value="">--- Tüm Soru Türleri (Filtresiz) ---</option>
                            {rules?.types && Object.entries(rules.types).map(([key, val]) => (
                                <option key={key} value={key}>{val.label || key}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4 text-end">
                        <button 
                            className="btn btn-primary"
                            onClick={() => {
                                setModalMode("create");
                                setCurrentId(null);
                                const defaultType = "choice";
                                const defRule = rules?.types?.[defaultType];
                                setFormData({
                                    name: "", description: "", content_type: defaultType, tag_id: 1,
                                    title_media: defRule?.titleMedia?.[0] || "text", 
                                    left_media: defRule?.leftMedia ? defRule.leftMedia[0] : "", 
                                    answer_media: defRule?.answerMedia ? defRule.answerMedia[0] : "",
                                    answer_language: "en", instruction: defRule?.instructions?.[0] || "", 
                                    item_count: defRule?.itemCount?.default || 3, 
                                    option_count: defRule?.optionCount?.default || 3,
                                    piece_mode: defRule?.pieceMode?.default || "letters", 
                                    notfy_text: rules?.defaultNotfyText || "",
                                    sortid: 0
                                });
                                setShowModal(true);
                            }}
                        >
                            + Yeni Şablon Oluştur
                        </button>
                    </div>
                </div>
            </div>

            {/* LİSTELEME */}
            {loading ? (
                <div className="text-center mt-5"><div className="spinner-border text-primary" role="status"></div></div>
            ) : templates.length === 0 ? (
                <div className="alert alert-info text-center py-4">Kayıtlı soru şablonu bulunamadı.</div>
            ) : (
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                    {templates.map((tpl) => {
                        const typeInfo = rules?.types?.[tpl.content_type];
                        return (
                            <div key={tpl.id} className="col">
                                <div className="card h-100 shadow-sm border-0">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                            <h5 className="card-title fw-bold text-dark m-0">{tpl.name}</h5>
                                        </div>
                                        <span className="badge bg-info text-dark mb-2">Tür: {typeInfo?.label || tpl.content_type}</span>
                                        <p className="card-text text-muted small mb-3">{tpl.description || typeInfo?.description || "Açıklama yok."}</p>
                                        
                                        <ul className="list-unstyled small text-secondary border-top pt-2">
                                            <li><strong>Başlık Medyası:</strong> {tpl.title_media}</li>
                                            {tpl.left_media && <li><strong>Sol Medya:</strong> {tpl.left_media}</li>}
                                            {tpl.answer_media && <li><strong>Cevap Medyası:</strong> {tpl.answer_media}</li>}
                                            <li><strong>Yönerge:</strong> {tpl.instruction}</li>
                                        </ul>
                                    </div>
                                    <div className="card-footer bg-white border-0 d-flex justify-content-end gap-2 pb-3">
                                        <button className="btn btn-sm btn-outline-info" onClick={() => handleDuplicate(tpl.id)} title="Kopyala">📋</button>
                                        <button 
                                            className="btn btn-sm btn-outline-warning" 
                                            onClick={() => {
                                                setModalMode("edit");
                                                setCurrentId(tpl.id);
                                                setFormData(tpl);
                                                setShowModal(true);
                                            }}
                                            title="Düzenle"
                                        >
                                            ✏️
                                        </button>
                                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(tpl.id)} title="Sil">🗑️</button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}

            {/* --- SADELEŞTİRİLMİŞ OLUŞTURMA / DÜZENLEME MODALI --- */}
            {showModal && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <form onSubmit={handleSubmit}>
                                <div className="modal-header">
                                    <h5 className="modal-title">{modalMode === "create" ? "Yeni Soru Şablonu Oluştur" : "Şablonu Düzenle"}</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                                </div>
                                <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                                    
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">Şablon Adı </label><i>Şablonları karıştırmamanız için isimlendirebilirsiniz.</i>
                                            <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} required />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">Soru Türü (Content Type)</label>
                                            <select className="form-select" name="content_type" value={formData.content_type} onChange={handleContentTypeChange} disabled={modalMode === "edit"}>
                                                {rules?.types && Object.entries(rules.types).map(([key, val]) => (
                                                    <option key={key} value={key}>{val.label} ({key})</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {/* Tür Açıklaması */}
                                    {activeRule?.description && (
                                        <div className="alert alert-secondary py-2 small mb-3">
                                            💡 <strong>Tür Bilgisi:</strong> {activeRule.description}
                                        </div>
                                    )}

                                    <div className="mb-3">
                                        <label className="form-label">Açıklama / Not</label>
                                        <textarea className="form-control" name="description" value={formData.description || ""} onChange={handleChange} rows={2} />
                                    </div>

                                    <div className="row mb-3">
                                        {/* Başlık Medyası */}
                                        <div className="col-md-4">
                                            <label className="form-label">Başlık Medyası</label> <i>Soru başlığında ne olsun?</i>
                                            <select className="form-select" name="title_media" value={formData.title_media} onChange={handleChange}>
                                                {activeRule?.titleMedia?.map(m => (
                                                    <option key={m} value={m}>{rules?.mediaLabels?.[m] || m}</option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Sol Medya (Sadece realmatch vb. varsa) */}
                                        {activeRule?.leftMedia && (
                                            <div className="col-md-4">
                                                <label className="form-label">Sol Taraf Medyası</label>
                                                <select className="form-select" name="left_media" value={formData.left_media || ""} onChange={handleChange}>
                                                    {activeRule.leftMedia.map(m => (
                                                        <option key={m} value={m}>{rules?.mediaLabels?.[m] || m}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}

                                        {/* Cevap Medyası (Varsa) */}
                                        {activeRule?.answerMedia && (
                                            <div className="col-md-4">
                                                <label className="form-label">Cevap / Şık Medyası</label> <i>cevapta ne olsun?</i>
                                                <select className="form-select" name="answer_media" value={formData.answer_media || ""} onChange={handleChange}>
                                                    {activeRule.answerMedia.map(m => (
                                                        <option key={m} value={m}>{rules?.mediaLabels?.[m] || m}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}
                                    </div>

                                    {/* Cevap Dili (answerLanguage true ise) */}
                                    {activeRule?.answerLanguage && (
                                        <div className="mb-3">
                                            <label className="form-label">Cevap Dili</label> <i>cevaplarda metin kullanılacaksa, kullanılacak olan metnin dili ne olsun</i>
                                            <select className="form-select" name="answer_language" value={formData.answer_language || "en"} onChange={handleChange}>
                                                {rules?.languages && Object.entries(rules.languages).map(([k, v]) => (
                                                    <option key={k} value={k}>{v}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )}

                                    {/* Yönerge (Instruction ve Hazır Öneriler) */}
                                    <div className="mb-3">
                                        <label className="form-label fw-bold">Yönerge (Soru Metni)</label>
                                        <input type="text" className="form-control mb-2" name="instruction" value={formData.instruction} onChange={handleChange} placeholder="Örn: Look, read and choose." required maxLength={500} />
                                        {activeRule?.instructions && (
                                            <div className="d-flex flex-wrap gap-1">
                                                <small className="text-muted w-100">Hazır Yönerge Önerileri (Tıklayın):</small>
                                                {activeRule.instructions.map((inst, idx) => (
                                                    <button 
                                                        key={idx} 
                                                        type="button" 
                                                        className="badge bg-light text-dark border border-secondary text-start"
                                                        onClick={() => setFormData(prev => ({ ...prev, instruction: inst }))}
                                                    >
                                                        {inst}
                                                    </button>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    <div className="row mb-3">
                                        {/* Item Count (Şık/Boşluk/Çift sayısı) */}
                                        {activeRule?.itemCount && (
                                            <div className="col-md-4">
                                                <label className="form-label">{activeRule.itemCount.label}</label>
                                                <input 
                                                    type="number" 
                                                    className="form-control" 
                                                    name="item_count" 
                                                    value={formData.item_count ?? activeRule.itemCount.default} 
                                                    onChange={handleChange} 
                                                    min={activeRule.itemCount.min} 
                                                    max={activeRule.itemCount.max} 
                                                />
                                            </div>
                                        )}
                                        
                                        {/* Option Count (Sadece sentence türü için her boşluktaki seçenek sayısı) */}
                                        {activeRule?.optionCount && (
                                            <div className="col-md-4">
                                                <label className="form-label">{activeRule.optionCount.label}</label>
                                                <input 
                                                    type="number" 
                                                    className="form-control" 
                                                    name="option_count" 
                                                    value={formData.option_count ?? activeRule.optionCount.default} 
                                                    onChange={handleChange} 
                                                    min={activeRule.optionCount.min} 
                                                    max={activeRule.optionCount.max} 
                                                />
                                            </div>
                                        )}

                                        <div className="col-md-4">
                                            <label className="form-label">Sıra (Sort ID)</label> <i>şablonun sıralamadaki yeri</i>
                                            <input type="number" className="form-control" name="sortid" value={formData.sortid} onChange={handleChange} />
                                        </div>
                                    </div>

                                    {/* Piece Mode (Sadece match türü için harf/kelime seçimi) */}
                                    {activeRule?.pieceMode && (
                                        <div className="mb-3">
                                            <label className="form-label">{activeRule.pieceMode.label}</label>
                                            <select className="form-select" name="piece_mode" value={formData.piece_mode || activeRule.pieceMode.default} onChange={handleChange}>
                                                {Object.entries(activeRule.pieceMode.options).map(([k, v]) => (
                                                    <option key={k} value={k}>{v}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )}

                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>İptal</button>
                                    <button type="submit" className="btn btn-primary">Kaydet</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminQuestionTemplates;